module.exports = "<div class=header-content-block> <a href=https://www.barclaycard.co.uk target=_blank rel=\"noopener noreferrer\" aria-label=\"{{ 'login.header.logo.title' | translate }}\"> <span class=sr-only>{{ 'login.header.logo.title' | translate }}</span> <div class=logo></div> </a> <div class=header-text> <language-selector></language-selector> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/login/header/bcb.pageHeader.html
// module id = 593
// module chunks = 0